import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import SpinnerLoader from "../../../Utils/Spinner";
import "../../../assets/css/StudentShortDetails.css"; // import your CSS
import { FeeApprovalsTemplateSucessFullModal } from "../../../Component/Modals/FeeApprovalsTemplateSuccessFullModal";
import TableSkeleton from "../../../Utils/TableSkeleton";
import { getData, Postdata, PostdataWithoutToken, postDataWithToken } from "../../../API/GlobalApi";
import Notifier from "../../../Utils/notify";

const ExceptionalCaseFeeDueApprovals = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { uniqueId } = useParams();   // activity_id


    const signature = queryParams.get("signature");
    const user_id = queryParams.get("user_id");
    const student_id = queryParams.get("student_id");
    const activity_id = queryParams.get("activity_id");

    const navigate = useNavigate();
    const [feePlanData, setFeePlanData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [remark, setRemark] = useState("");
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const getFeePlanData = async () => {
        try {
            console.log("students_id", student_id);

            const res = await getData(
                `academics/activities/student-ledger-balance/?student_id=${student_id}`
            );

            console.log("res", res);

            if (res) {
                // Create your structured data object
                const formatted = {
                    student_name: res.student_name,
                    registration_number: res.registration_number,
                    course: res.course,
                    student_id: res.student_id,
                    amount_due: res.amount_due,
                    amount_paid: res.amount_paid,
                    pending_amount: res.pending_amount,
                    fullData: res       // optionally store full response
                };

                setFeePlanData(formatted);
            }

        } catch (error) {
            console.error("Error fetching fee plan data:", error);
            Notifier.error("Failed to load data");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (student_id) {
            getFeePlanData();
        }
    }, [student_id]);





    if (loading) {
        return (
            <div className="container">
                <div className="d-flex justify-content-center align-items-center vh-100 text-muted">
                    <TableSkeleton />
                </div>
            </div>
        );
    }


    if (!feePlanData) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 text-danger text-center impose-responsive-font">
                No fee plan details found for ID: {uniqueId}
            </div>
        );
    }


    const handleAction = async (isApproved) => {
        try {
            const url = `academics/activities/approve-exceptional-approval/?signature=${encodeURIComponent(
                signature
            )}&user_id=${encodeURIComponent(user_id)}`;

            const payload = {
                activity_id: activity_id,
                student_id: student_id,
                is_approved: isApproved,
                // remark: remark || ""   // optional
            };

            const response = await PostdataWithoutToken(url, payload);

            if (response.error || response.detail) {
                Notifier.error(response.error || response.detail);
                return;
            }

            if (isApproved === 1) {
                // APPROVED
                navigate("/fee-approval-success", { state: { type: "exceptional_due" } });
            } else {
                // REJECTED
                Notifier.success("Fee plan rejected successfully!");
                navigate("/fee-approval-cancel");
            }

        } catch (error) {
            console.error("Error updating approval:", error);
            Notifier.error("Something went wrong");
        }
    };



    return (
        <>

            <div className="container py-4 impose-responsive-font">
                <h2 className="text-center mt-5 mb-4 impose-responsive-font templateFeeTitles">
                    Exceptional Fee Due Approval Request
                </h2>

                {/* Top Section */}
                <div className="row g-3 mb-4 mt-4 impose-responsive-font detailsContainer">
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Student:</strong>
                        <div>{feePlanData.student_name}({feePlanData?.registration_number})</div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Course:</strong>
                        <div>{feePlanData?.course}</div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Due:</strong>
                        <div>{feePlanData?.amount_due}</div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Paid Amount:</strong>
                        <div>{feePlanData?.amount_paid}</div>
                    </div>


                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Pending Amount:</strong>
                        <div>{feePlanData?.pending_amount}</div>
                    </div>



                </div>


                {/* Remark & Buttons */}
                <div className="row g-3 align-items-end impose-buttons mt-3">
                    <div className="col-12 col-md-6">
                        {/* <label className="form-label impose-form-label">Remark</label>
                        <input
                            type="text"
                            id="remark"
                            className="form-control"
                            placeholder="Enter your remark"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                        /> */}
                    </div>

                    <div className="col-12 col-md-6 d-flex justify-content-start justify-content-md-end align-items-center gap-2 btnContainers">
                        <button className="add-btn px-4" onClick={() => handleAction(1)}>
                            Approve
                        </button>
                        <button className="btn btn-secondary px-4" onClick={() => handleAction(0)}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>


        </>
    );
};

export default ExceptionalCaseFeeDueApprovals;
